import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=4541a8b4&scoped=true"
import script from "./Drawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Drawer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Drawer.vue?vue&type=style&index=0&id=4541a8b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4541a8b4",
  null
  
)

export default component.exports